import BossModel from "@/models/BossModel";
import Agent from "@/models/Agent/Agent";
import Type from "@/models/Product/Type/Type";
import Margin from "@/models/Margin/Margin";

export default class DefaultMargin extends BossModel {

    static apiUrl = 'agent/default-margin';

    /**
     *
     * @type {string}
     */
    static entity = 'AgentDefaultMargins';

    static fields() {
		return {
			id: this.number(null).nullable(),
            agent_id: this.number(null),
            product_type_id: this.number(null),
            margin_id: this.number(null),
            agent: this.belongsTo(Agent, 'agent_id'),
            margin: this.belongsTo(Margin, 'margin_id'),
            product_type: this.belongsTo(Type, 'product_type_id'),
        }
	}
}
